/**
 * Deakin pagination bar — results summary + page nav (used above and below results).
 */
import type { RefObject } from 'react';
import SearchPagination from '../search-pagination';
import SearchResultsSummary from '../search-results-summary';

type Props = {
  searchRef: RefObject<HTMLDivElement | null>;
  position?: 'before' | 'after';
};

const SearchPaginationBar = ({ searchRef, position = 'before' }: Props) => (
  <div
    className={
      position === 'after' ? 'pagination pagination--after-results' : 'pagination'
    }
  >
    <div>
      <SearchResultsSummary />
    </div>
    <SearchPagination searchRef={searchRef} />
  </div>
);

export default SearchPaginationBar;
